export function IndexComponent() {
  return null;
}
